interface BoldDiagonalRedProps {
  /** ラインの配置パターン */
  pattern?: "cross" | "single" | "triple" | "corner" | "full";
  /** 赤いラインの上にコンテンツが重なるとき true（pointer-events調整） */
  allowOverlap?: boolean;
  className?: string;
  /** z-index */
  zIndex?: number;
  /** ラインの不透明度 */
  opacity?: number;
  /** ref */
  ref?: React.Ref<HTMLDivElement>;
}

/**
 * careerscout.co.jp 風の太い赤い斜めライン。
 * pattern:
 *   cross    — 1本の短い斜めライン（左上隅付近）
 *   single   — 1本の大きな斜めライン
 *   triple   — 2本の並行斜めライン
 *   corner   — 隅から伸びる短い斜めライン
 *   full     — 画面を貫く超太い1本
 */
export default function BoldDiagonalRed({
  pattern = "cross",
  allowOverlap = false,
  className = "",
  zIndex = 0,
  opacity = 1,
  ref,
}: BoldDiagonalRedProps) {
  const red = "#c00000";
  const lightRed = "rgba(192, 0, 0, 0.15)";

  const patterns: Record<string, Array<{
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
    width: string;
    height: number;
    angle: number;
    color: string;
    origin: string;
  }>> = {
    cross: [
      { top: "15%", left: "5%", width: "clamp(100px, 10vw, 160px)", height: 12, angle: 45, color: red, origin: "left center" },
    ],
    single: [
      { top: "20%", left: "-15%", width: "150%", height: 16, angle: 20, color: red, origin: "left center" },
    ],
    triple: [
      { top: "10%", left: "-10%", width: "130%", height: 8, angle: 18, color: red, origin: "left center" },
      { top: "60%", right: "-5%", width: "110%", height: 6, angle: -14, color: lightRed, origin: "right center" },
    ],
    corner: [
      { top: "0", left: "0", width: "40%", height: 10, angle: 35, color: red, origin: "left top" },
    ],
    full: [
      { top: "45%", left: "-20%", width: "180%", height: 24, angle: 18, color: red, origin: "left center" },
    ],
  };

  const lines = patterns[pattern] ?? patterns.cross;

  return (
    <div
      ref={ref}
      className={`absolute inset-0 overflow-hidden ${allowOverlap ? "" : "pointer-events-none"} ${className}`}
      style={{ zIndex, opacity }}
    >
      {lines.map((line, i) => (
        <div
          key={i}
          className="absolute hidden lg:block"
          style={{
            top: line.top,
            left: line.left,
            right: line.right,
            bottom: line.bottom,
            width: line.width,
            height: `${line.height}px`,
            background: line.color,
            transform: `rotate(${line.angle}deg)`,
            transformOrigin: line.origin,
          }}
        />
      ))}
    </div>
  );
}